export const apiError = (error, fallback = "Something went wrong. Please try again.") => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(item => item.msg).filter(Boolean).join("; ");
  return fallback;
};

export const describeGenerateError = (error) => {
  const status = error?.response?.status;
  const detail = error?.response?.data?.detail;
  if (status === 402 || detail === "ai_quota_exhausted") {
    return "AI email generation is unavailable because the AI service has hit its usage limit. Please contact the campaign organiser — they need to top up their AI account.";
  }
  if (["ai_key_invalid", "ai_provider_configuration_error", "No AI key configured. Please contact support."].includes(detail)) {
    return "AI email generation is unavailable due to a configuration problem. Please contact the campaign organiser.";
  }
  if ([502, 503, 504].includes(status)) {
    return "We couldn't generate your email right now. Please try again in a few moments.";
  }
  return "Failed to generate email. Please try again.";
};